<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT">About the Author</h1>
<p class="p">When Sabrine was just six years old, she would buy books and write the shortest stories imaginable. She always dreamed of becoming a successful writer. She would often bring her incomplete stories to her dad and ask, ‘can you sell it?’ and he would say ‘yes, I will!’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?82f933b0